/// <amd-module name="Build/Admin/Common/Actions/ConfirmationDialogActionCreator" />
import { ConfirmationDialogActions, ConfirmButtonType } from "Build/Admin/Common/Actions/ConfirmationDialogActions";

export interface IConfirmationDialogOptions<T> {
    confirmationDialogActions: ConfirmationDialogActions<T>;
}

export class ConfirmationDialogActionCreator<T> {
    private _confirmationDialogActions: ConfirmationDialogActions<T>;

    constructor(options: IConfirmationDialogOptions<T>) {
        this._confirmationDialogActions = options.confirmationDialogActions;
    }

    public showConfirmationDialog(
        selectedItem: T,
        title: string,
        content: string | JSX.Element,
        confirmButtonType: ConfirmButtonType,
        onConfirm: (item: T) => void,
        onCancel: () => void
    ): void {
        this._confirmationDialogActions.showConfirmationDialog.invoke({ selectedItem, title, content, confirmButtonType, onConfirm, onCancel });
    }

    public dismissConfirmationDialog(): void {
        this._confirmationDialogActions.dismissConfirmationDialog.invoke(undefined);
    }
}
